import {getCustomerAsync, saveCustomerAsync} from "./customersSlice";
import React, {useEffect, useRef, useState} from "react";
import {useMsal} from "@azure/msal-react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useParams} from "react-router-dom";
import {Button, Col, Form, FormGroup, InputGroup, Row} from "react-bootstrap";
import {Formik} from "formik";
import {apiRequest, loginRequest} from "../../authConfig";
import styles from './Customers.module.css';
import {setActiveLink} from "../navmenu/navbarSlice";
import {useNavigate} from "react-router-dom";
import { connect } from "react-redux";

export const EditCustomer = () => {

    const formicRef = useRef<any>(null);
    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const customer = useAppSelector(state => state.customers.customer);
    const failed = useAppSelector(state => state.customers.status === 'failed');
    const navigate = useNavigate();
    let {id} = useParams();

    const [saved, setSaved] = useState<boolean>(false);

    useEffect(() => {
        if (saved && !failed) {
            navigate('/customers');
        }

        setSaved(false);
    }, [saved, dispatch, customer, failed]);

    useEffect(() => {
            dispatch(setActiveLink('/customers'));
            const fetch = async () => {
                await fetchCustomer();
            }

            fetch();
        },
        [
            id,
            dispatch
        ]);

    const requestApiAccessToken = async (): Promise<string> => {
        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        }
    };

    const getCustomerId = () => {
        return id ?? '';
    }

    const fetchCustomer = async () => {

        const customerId = getCustomerId()
        if (customerId == '') {
            return;
        }

        await dispatch(getCustomerAsync({
            apiToken: await requestApiAccessToken(),
            id: customerId
        }));
    }

    const saveCustomer = async ({name, active}
                                    : { name: string | undefined, active: boolean | undefined }) => {

        await dispatch(saveCustomerAsync({
            data: {
                id: customer?.id ?? '',
                name: name ?? '',
                active: active ?? false,
                created: customer?.created,
                lastModified: customer?.lastModified
            },
            apiToken: await requestApiAccessToken(),
        }));

        setSaved(true);
    }
    return (
        <Row>
            <Col xs={12}>
                <Formik
                    validateOnChange={true}
                    validateOnMount={true}
                    innerRef={formicRef}
                    enableReinitialize={true}
                    initialValues={{
                        name: customer?.name ?? '',
                        active: customer?.active ?? false
                    }}
                    onSubmit={console.log}
                    validate={values => {
                        const errors: { [key: string]: any } = {};
                        if (!values?.name) {
                            errors.name = 'Required';
                        }
                        return errors;
                    }}
                >
                    {({
                          handleChange,
                          values,
                          errors,
                          dirty
                      }) => (
                        <Form>
                            <Row>
                                <Col className="col-12 col-lg-6 mb-2">
                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                id="name"
                                                name="name"
                                                type="text"
                                                value={values.name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.name}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col className="col-12">
                                    <Form.Group>
                                        <InputGroup/>
                                        <Form.Check type="checkbox">
                                            <Form.Check.Label>Enabled</Form.Check.Label>
                                            <Form.Check.Input
                                                id="active"
                                                name="active"
                                                type="checkbox"
                                                checked={values.active}
                                                onChange={handleChange}
                                            />
                                        </Form.Check>
                                    </Form.Group>
                                </Col>
                                <Col className="col-12 col-lg-6 mb-2">
                                    <div className={styles.right}>
                                        <FormGroup>
                                            <InputGroup>
                                                <Button
                                                    disabled={!!errors.name || !dirty || !customer}
                                                    onClick={() => saveCustomer(values)}
                                                >
                                                    Save
                                                </Button>
                                            </InputGroup>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )
                    }
                </Formik>
            </Col>
        </Row>
    )
}

export default connect()(EditCustomer);
